import { FontIcon } from 'office-ui-fabric-react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { IModalDialog } from '../../../models/IModalDialog';
import { IVerificationProps } from './IVerificationProps';
import { IVerificationState } from './IVerificationState';

const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "12px", color: '#005269'
});
const topMsgPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
const successMsgPanel = mergeStyles({
    color: 'green', fontSize: "14px", textAlign: "center"
});
const iconPanel = mergeStyles({
    paddingRight: "3px"
});
export default class Verification extends React.Component<IVerificationProps, IVerificationState>
{
    private dialog: IModalDialog;
    constructor(props: IVerificationProps, state: IVerificationState) {
        super(props);
        this.state = {
            inputError: 'This field is Required',
            showError: false,
            isValidData: false
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async componentDidMount() {
        let code: string | undefined = this.props.connectionContext.getQueryStringByParameter('code');
        if (code !== undefined && code !== null) {
            this.verifyActivationCode(code);
        }
    }
    public render(): React.ReactElement<IVerificationProps> {
        return (
            <div className={panel}>
                <div className={topMsgPanel}>
                    <h4>{(this.state.isValidData) ? "Your account is successfully verified" : "Account verification"}</h4>
                </div>
                {
                    (this.state.isValidData) && (
                        <div>
                            <div>
                                <p className={successMsgPanel}><FontIcon iconName="Completed" className={iconPanel} />Please <Link href="../User/Login/Login">click here</Link> to login with your user id and password.</p>
                            </div>
                        </div>)
                }
            </div>
        );
    }
    private verifyActivationCode = async (code: string): Promise<void> => {
        try {
            await this.props.connectionContext.put(`Register/${code}/verify`, {});
            this.setState({ isValidData: true });
        } catch (excpetion) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IVerificationState, props: IVerificationProps): IVerificationState => {
            previousState.isValidData = false;
            return previousState;
        });
    }
}